<section id="container" #playlistContainer>
  @for (video of videos(); track video.position; let i = $index) {
    @if (video.position === nowPlaying().position) {
      <div class="current">
        <h1>Hetkel mängib</h1>
      </div>
    }
    <div
      [attr.data-position]="video.position"
      [class.active]="video.position === nowPlaying().position"
      [class.disable]="video.position < nowPlaying().position">
      <youtube-thumbnail
        [isDesktop]="video.position !== nowPlaying().position"
        [video]="video"></youtube-thumbnail>
    </div>
  }
</section>
